import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_layout_aside = _resolveComponent("vxe-layout-aside");
  return _openBlock(), _createBlock(_component_vxe_layout_aside, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _createSlots({
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots), key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
    };
  })]), 1040);
}